import { defineComponent as _defineComponent } from 'vue'


  
export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    modelValue: Boolean,
    label: String,
    disabled: Boolean,
    checkedPartial: Boolean,
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

const __returned__ = { props, emits }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})